<template>
  <div class="row p-0 cartao-semsa">
    <div class="col-12">
      <div class="container">
        <!-- Primeira linha -->
        <div class="row d-flex align-items-stretch">
          <div class="col-md-9 col-9 d-flex">
            <div
              class="p-1 border-dashed text-center w-100 d-flex align-items-center justify-content-center"
            >
              <img class="img-fluid" width="50%" src="img/logosemsamao.png" />
            </div>
          </div>
          <div class="col-md-3 col-3 ml-auto d-flex">
            <div
              class="p-1 border-dashed w-100 d-flex flex-column align-items-center justify-content-center"
            >
              <h4 class="font-weight-bold">FOLHA DE FREQUÊNCIA</h4>
              <h5>
                PERÍODO:
                <span>{{
                  moment(periodo.de)
                    .locale("pt-br")
                    .format("MMMM YYYY")
                }}</span>
              </h5>
            </div>
          </div>
        </div>

        <!-- Segunda linha -->
        <div class="row border-dashed-row my-1 m-0 p-0 justify-content-center">
          <div class="col-md-6 col-6">
            <div class="p-1 text-left">
              <h5>
                NOME:
                <span class="font-weight-bold">
                  {{
                    dados.dadosEmpregado.empregado
                      ? dados.dadosEmpregado.empregado
                      : "-"
                  }}
                </span>
              </h5>
              <h5>
                MATRICULA:
                <span class="font-weight-bold">{{
                  dados.dadosEmpregado.matricula
                    ? dados.dadosEmpregado.matricula
                    : "-"
                }}</span>
              </h5>
              <h5>
                CARGO:<span class="font-weight-bold">{{
                  dados.dadosEmpregado.funcao
                    ? dados.dadosEmpregado.funcao
                    : "-"
                }}</span>
              </h5>
            </div>
          </div>
          <div class="col-md-6 col-6">
            <div class="p-1 text-left">
              <h5>
                JORNADA DO SERVIDOR(A)/BOLSISTA:
                <span class="font-weight-bold">
                  {{ dados.dadosEmpregado.jornada }}
                </span>
              </h5>
              <h5>
                DEP./LOT.:
                <span class="font-weight-bold"
                  >{{
                    dados.dadosEmpregado.departamento
                      ? dados.dadosEmpregado.departamento
                      : "-"
                  }}
                  {{
                    dados.dadosEmpregado.local
                      ? " / " + dados.dadosEmpregado.local
                      : ""
                  }}</span
                >
              </h5>
              <h5>
                CHEFIA IMEDIATA:
                <span class="font-weight-bold">{{
                  dados.dadosEmpregado.chefia || ""
                }}</span>
              </h5>
            </div>
          </div>
        </div>

        <!-- terceira linha -->
        <div class="row border-dashed-row m-0 p-0">
          <div class="d-flex  w-100">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th scope="col">DATA</th>
                  <th scope="col">ENT.EXP</th>
                  <th scope="col">SAÍ.INT.</th>
                  <th scope="col">ENT.INT.</th>
                  <th scope="col">SAÍ.EXP</th>
                  <th scope="col">CARGA HORÁRIA</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in dados.horarios" :key="item.data">
                  <td>{{ item.data }}</td>
                  <td
                    role="button"
                    @click="
                      abrirModalBatidaManual(
                        item.dadosBatidas[0] || item.day,
                        dados.dadosEmpregado.matricula
                      )
                    "
                  >
                    {{
                      item.batidas.length >= 1
                        ? gerarLabelHorario(item.dadosBatidas[0])
                        : "***"
                    }}
                  </td>
                  <td
                    role="button"
                    @click="
                      abrirModalBatidaManual(
                        item.dadosBatidas[1] || item.day,
                        dados.dadosEmpregado.matricula
                      )
                    "
                  >
                    {{
                      item.batidas.length >= 2
                        ? gerarLabelHorario(item.dadosBatidas[1])
                        : "***"
                    }}
                  </td>
                  <td
                    role="button"
                    @click="
                      abrirModalBatidaManual(
                        item.dadosBatidas[2] || item.day,
                        dados.dadosEmpregado.matricula
                      )
                    "
                  >
                    {{
                      item.batidas.length >= 3
                        ? gerarLabelHorario(item.dadosBatidas[2])
                        : "***"
                    }}
                  </td>
                  <td
                    role="button"
                    @click="
                      abrirModalBatidaManual(
                        item.dadosBatidas[3] || item.day,
                        dados.dadosEmpregado.matricula
                      )
                    "
                  >
                    {{
                      item.batidas.length >= 4
                        ? gerarLabelHorario(item.dadosBatidas[3])
                        : "***"
                    }}
                  </td>
                  <td>
                    {{
                      selecionarLabelHorario(
                        item,
                        dados.abonos,
                        dados.afastamentos
                      )
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- quarta linha -->
        <div class="row border-dashed-row my-1 m-0 p-0 justify-content-center">
          <div class="col-md-3 col-3">
            <div class="p-1 text-left">
              <h5>
                Atrasos:
                <span class="font-weight-bold">
                  {{ dados.totais.atrasos }}
                </span>
              </h5>
              <h5>
                Batidas Inválidas:
                <span class="font-weight-bold"> </span>
              </h5>
              <h5>
                Fins de semana:
                <span class="font-weight-bold"> </span>
              </h5>
            </div>
          </div>
          <div class="col-md-3 col-3">
            <div class="p-1 text-left">
              <h5>
                Saídas Antecipadas:
                <span class="font-weight-bold"> </span>
              </h5>
              <h5>
                Férias:
                <span class="font-weight-bold"> </span>
              </h5>
              <h5>
                Feriados:
                <span class="font-weight-bold"> </span>
              </h5>
            </div>
          </div>
          <div class="col-md-3 col-3">
            <div class="p-1 text-left">
              <h5>
                Ausências de batidas:
                <span class="font-weight-bold"> </span>
              </h5>
              <h5>
                Licenças/Afastamentos:
                <span class="font-weight-bold"> </span>
              </h5>
              <h5>
                Pontos Facultativos:
                <span class="font-weight-bold"> </span>
              </h5>
            </div>
          </div>
          <div class="col-md-3 col-3">
            <div class="p-1 text-left">
              <h5>
                Faltas:
                <span class="font-weight-bold">
                  {{ dados.totais.faltasDias }}
                </span>
              </h5>
              <h5>
                Dias trabalhados:
                <span class="font-weight-bold">
                  {{ dados.totais.diasTrabalhados }}
                </span>
              </h5>
              <h5>
                Horas trabalhadas:
                <span class="font-weight-bold">
                  {{ dados.totais.exercidas }}
                </span>
              </h5>
            </div>
          </div>
        </div>

        <!-- quinta linha -->
        <div class="row border-dashed-row my-1 m-0 p-0 justify-content-center">
          <div class="col-md-12 col-12">
            <div class="p-1 text-left">
              <div class="row mb-0 p-0 justify-content-center">
                <h5 class="col-md-2 col-2">Assinatura Servidor(a)/Bolsista:</h5>
                <div
                  class="col-md-10 col-10 border border border-dark"
                  style="height: 25px;"
                ></div>
              </div>

              <div class="row mb-0 p-0 justify-content-center">
                <h5 class="col-md-2 col-2">Assinatura Chefia Imediata:</h5>
                <div
                  class="col-md-10 col-10 border border border-dark"
                  style="height: 25px;"
                ></div>
              </div>

              <div class="row mb-0 p-0 justify-content-center">
                <h5 class="col-md-2 col-2">Observações:</h5>
                <div
                  class="col-md-10 col-10 border border border-dark"
                  style="height: 25px;"
                ></div>
              </div>
            </div>
          </div>
        </div>

        <!-- sexta linha -->
        <div class="row border-dashed-row my-1 m-0 p-0 justify-content-center">
          <div class="col-md-12 col-12">
            <div class="m-0 pt-1">
              <h5>
                Guia de legendas: FDS – Fim de semana / PFI – Ponto facultativo
                integral /PFP – Ponto facultativo parcial / FR – Feriado / FS –
                Férias / LI – Licença / DT – Dia trabalhado / FT – Falta
              </h5>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="spinner"
        color="#35a887"
        :is-full-page="true"
      >
      </loading>
    </div>

    <!--So abre o modal se tiver configurado no banco para fazer batida manual-->
    <modal :show.sync="modalBatidaManual && dados.config.batidaManual == 1">
      <template slot="header">
        <h4 class="modal-title" id="exampleModalLabel">
          Batida Manual
        </h4>
      </template>

      <div class="p-3">
        <div class="row">
          <span v-if="postos.length == 0" class="text-danger"
            >Não é possível registrar batida manual, autorize um posto de
            trabalho para continuar</span
          >

          <el-select
            v-if="postos.length > 1"
            class="select-success mb-3 pagination-select"
            :class="erros.empregador === true ? 'has-danger' : ''"
            placeholder="Selecione um posto de trabalho"
            v-model="dataBatidaManual.id_empregador"
          >
            <el-option
              class="select-success"
              v-for="item in postos"
              :key="item.ID_EMPREGADOR"
              :value="item.ID_EMPREGADOR"
              :label="item.DS_LOCAL"
              >{{ item.DS_LOCAL }}
            </el-option>
          </el-select>

          <base-input
            label="Data:"
            class="col-12 text-left"
            :class="erros.data === true ? 'has-danger' : ''"
            type="date"
            v-model="dataBatidaManual.data_batida"
          >
          </base-input>

          <base-input
            label="Hora:"
            class="col-12 text-left"
            :class="erros.hora === true ? 'has-danger' : ''"
            type="time"
            v-model="dataBatidaManual.hora_batida"
          >
          </base-input>
        </div>
      </div>
      <template slot="footer">
        <base-button type="danger" @click="modalBatidaManual = false"
          >Fechar</base-button
        >
        <base-button type="success" @click="cadastrarBatidaManual()"
          >Salvar</base-button
        >
      </template>
    </modal>

    <modal :show.sync="modalAbonoManual">
      <AbonosInserir
        v-if="modalAbonoManual"
        :dados="dataAbono.data"
        :funcionario="dataAbono.funcionario"
        :config="dados.config"
        @fecharModalAbono="fecharModalAbono"
      />
    </modal>

    <modal :show.sync="modalOcorrencia">
      <OcorrenciasInserir
        v-if="modalOcorrencia"
        :dados="dataOcorrencia.data"
        :funcionario="dataOcorrencia.funcionario"
        @fecharModalOcorrencia="fecharModalOcorrencia"
      />
    </modal>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import { BaseInput, AbonosInserir, OcorrenciasInserir } from "./index";
import { Select, Option } from "element-ui";
import Modal from "@/components/Modal.vue";
import swal from "sweetalert2";
import moment from "moment";

export default {
  name: "BaseCartaoPontoSemsa",
  components: {
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    BaseInput,
    Modal,
    AbonosInserir,
    OcorrenciasInserir,
  },
  props: {
    dados: Object,
    periodo: Object,
    printing: Boolean,
  },
  data() {
    return {
      isLoading: false,
      modalAbonoManual: false,
      modalBatidaManual: false,
      modalOcorrencia: false,
      postos: Array,
      dataBatidaManual: {
        data_batida: "",
        hora_batida: "",
        id_empregador: "",
        dt_anterior: "",
        id: "",
        matricula: "",
      },
      dataAbono: {
        data: String,
        funcionario: String,
      },
      dataOcorrencia: {
        data: String,
        funcionario: String,
      },
      erros: {
        data: "",
        hora: "",
        empregador: "",
      },
    };
  },
  mounted() {},
  methods: {
    gerarLabelJornada(escalaDepartamento) {
      if (escalaDepartamento.length > 0) {
        let desc = "";
        for (const item of escalaDepartamento) {
          let batidas = "";
          console.log("-->", item);
          if (item.entrada_1 && item.saida_1) {
            batidas =
              batidas +
              `${moment(item.entrada_1).format("HH:mm")} - ${moment(
                item.saida_1
              ).format("HH:mm")}`;
          }
          if (item.entrada_2 && item.saida_2) {
            batidas =
              batidas +
              ` ${moment(item.entrada_2).format("HH:mm")} - ${moment(
                item.saida_2
              ).format("HH:mm")}`;
          }
          if (item.entrada_3 && item.saida_3) {
            batidas =
              batidas +
              ` ${moment(item.entrada_3).format("HH:mm")} - ${moment(
                item.saida_3
              ).format("HH:mm")}`;
          }
          if (item.entrada_4 && item.saida_4) {
            batidas =
              batidas +
              ` ${moment(item.entrada_4).format("HH:mm")} - ${moment(
                item.saida_4
              ).format("HH:mm")}`;
          }
          desc = `${desc} ${item.descricao} (${batidas}) <br>`;
        }

        return desc;
      }
      return "-";
    },
    limparModal() {
      this.dataBatidaManual.data_batida = "";
      this.dataBatidaManual.hora_batida = "";
      this.dataBatidaManual.id_empregador = "";
      this.dataBatidaManual.id = "";
      this.dataBatidaManual.dt_anterior = "";
      this.dataBatidaManual.matricula = "";
    },
    limparErrosModal() {
      this.erros = {
        data: "",
        hora: "",
        empregador: "",
      };
    },
    verificarErroModalBatida() {
      if (this.dataBatidaManual.data_batida == "") {
        this.erros.data = true;
      } else {
        this.erros.data = false;
      }

      if (this.dataBatidaManual.hora_batida == "") {
        this.erros.hora = true;
      } else {
        this.erros.hora = false;
      }

      if (!this.dataBatidaManual.id_empregador) {
        this.erros.empregador = true;
      } else {
        this.erros.empregador = false;
      }
    },
    formatarCpfCnpj(valor) {
      if (valor.length === 14) {
        valor = valor.padStart(14, "0");
        valor = valor.replace(
          /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
          "$1.$2.$3/$4-$5"
        );
      } else {
        valor = valor.padStart(11, "0");
        valor = valor.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
      }

      return valor;
    },
    selecionaStatus(item) {
      const { faltou, folga, feriado, afastamento } = item;
      if (faltou) return "tb-falta";
      if (folga) return "tb-folgas";
      if (feriado) return "tb-feriados";
      if (afastamento) return "tb-ferias";
      return "";
    },
    selecionarLabelHorario(item, abonosLista, afastamentosLista) {
      // prioridade -> falta, folga, feriado, afastamento
      const { folga, feriado, afastamento, abonos, day, exercidas } = item;

      if (abonos != "00:00") {
        const ab = abonosLista.filter((abl) => abl.data == day);
        return ab
          .map(
            (item) =>
              `${moment(item.hora, "HH:mm:ss").format("HH:mm")} - ${
                item.descricao
              }`
          )
          .join(", ");
      }

      if (folga) return "FOLGA";
      if (feriado) return "FERIADO";
      if (afastamento) {
        const afas = afastamentosLista.find((af) => {
          const ini = moment(af.data_inicial);
          const fim = moment(af.data_final);
          const dia = moment(day);
          if (dia.isBetween(ini, fim, undefined, "[]")) {
            return af;
          }
        });
        return `${afas.descricao || "AFASTAMENTO"}`;
      }

      return exercidas == "00:00" ? "***" : exercidas;
    },
    gerarLabelHorario(dados) {
      if (dados.tipoBatida == 3) {
        return `${moment(`${dados.data} ${dados.hora}`).format("HH:mm")}*`;
      } else {
        return `${moment(`${dados.data} ${dados.hora}`).format("HH:mm")}`;
      }
    },
    moment: function(data) {
      return moment(data);
    },
    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },
    // APIS
    listarPostosFuncionario() {
      const th = this;
      const bodyFormData = {
        cpf_empregado: this.dados.dadosEmpregado.cpf,
      };

      if (!bodyFormData.cpf_empregado) {
        return;
      }
      this.axios
        .post("/api/login/loginEmpregadoApenasCpf", bodyFormData)
        .then((response) => {
          if (response.data.data.dados && response.data.data.dados.length > 0) {
            th.postos = response.data.data.dados;
            if (response.data.data.dados.length == 1) {
              //coloca direto no campo
              th.dataBatidaManual.id_empregador =
                response.data.data.dados[0].ID_EMPREGADOR;
            }
          }
        })
        .catch((err) => {
          console.log(err);
          th.showSwal(
            "auto-close",
            "Erro",
            "Erro ao listar postos de trabalho!",
            "error"
          );
        });
    },
    cadastrarBatidaManual() {
      const th = this;
      const bodyFormData = {
        setDB: this.$cookies.get("db"),
        id_empregados: this.dados.dadosEmpregado.id,
        data_batida: this.dataBatidaManual.data_batida,
        hora_batida: this.dataBatidaManual.hora_batida,
        id_empregador: this.dataBatidaManual.id_empregador,
        id: this.dataBatidaManual.id || null,
        dt_anterior: this.dataBatidaManual.dt_anterior || null,
        matricula: this.dataBatidaManual.matricula || null,
      };
      if (
        bodyFormData.data_batida != "" &&
        bodyFormData.hora_batida != "" &&
        bodyFormData.id_empregador
      ) {
        this.isLoading = true;
        this.axios
          .post("/api/movimentacoes/baterPontoManual", bodyFormData)
          .then((response) => {
            th.isLoading = false;
            th.modalBatidaManual = false;
            if (response.data.data.status) {
              //batida com sucesso
              th.showSwal(
                "auto-close",
                "Sucesso",
                "Batida manual realizada com sucesso!",
                "success"
              );
              th.atualizarTable();
            } else {
              th.showSwal(
                "auto-close",
                "Erro",
                "Erro ao inserir batida manual!",
                "error"
              );
            }
          })
          .catch((err) => {
            console.log(err);
            th.isLoading = false;
            th.modalBatidaManual = false;
            th.showSwal(
              "auto-close",
              "Erro",
              "Erro ao inserir batida manual!",
              "error"
            );
          });
      } else {
        this.verificarErroModalBatida();
      }
    },
    // Modais
    async abrirModalBatidaManual(data, matricula) {
      this.limparModal();
      this.limparErrosModal();
      await this.listarPostosFuncionario();
      this.modalBatidaManual = true;
      if (typeof data == "object") {
        this.dataBatidaManual.data_batida = data.data;
        this.dataBatidaManual.hora_batida = data.hora;
        this.dataBatidaManual.id_empregador = data.id_empregador;
        this.dataBatidaManual.id = data.id;
        this.dataBatidaManual.matricula = data.matricula;
        if (data.id) {
          this.dataBatidaManual.dt_anterior = moment(
            `${data.data} ${data.hora}`
          ).format("YYYY-MM-DD HH:mm:ss");
        }
      } else {
        this.dataBatidaManual.data_batida = data;
        this.dataBatidaManual.matricula = matricula;
      }
    },
    abrirModalAbono(item) {
      this.dataAbono.data = item;
      this.dataAbono.funcionario = this.dados.dadosEmpregado.id;
      this.modalAbonoManual = true;
    },
    fecharModalAbono(atualizar) {
      this.modalAbonoManual = false;
      if (atualizar) {
        this.atualizarTable();
      }
    },
    abrirModalOcorrencia(item) {
      this.dataOcorrencia.data = item;
      this.dataOcorrencia.funcionario = this.dados.dadosEmpregado.id;
      this.modalOcorrencia = true;
    },
    fecharModalOcorrencia(atualizar) {
      this.modalOcorrencia = false;
      if (atualizar) {
        this.atualizarTable();
      }
    },
    atualizarTable() {
      this.$emit("atualizarTable", true);
    },
  },
};
</script>
<style>
.border-dashed {
  border: 2px dashed #777;
}

.border-dashed-row {
  border: 2px dashed #777;
  width: 100%;
  box-sizing: border-box;
}

.faltas {
  width: 25px;
  height: 20px;
  background: #db6153;
  border-radius: 7px 7px 7px 7px;
  -moz-border-radius: 7px 7px 7px 7px;
  -webkit-border-radius: 7px 7px 7px 7px;
  border: none;
  margin-right: 5px;
}

.tb-falta {
  background: #db6153;
}

.tb-feriados {
  background: #e37acc;
}

.tb-folgas {
  background: #6ece87;
}

.tb-ferias {
  background: #7a93e3;
}

.feriados {
  width: 25px;
  height: 20px;
  background: #e37acc;
  border-radius: 7px 7px 7px 7px;
  -moz-border-radius: 7px 7px 7px 7px;
  -webkit-border-radius: 7px 7px 7px 7px;
  border: none;
  margin-right: 5px;
}

.ferias {
  width: 25px;
  height: 20px;
  background: #7a93e3;
  border-radius: 7px 7px 7px 7px;
  -moz-border-radius: 7px 7px 7px 7px;
  -webkit-border-radius: 7px 7px 7px 7px;
  border: none;
  margin-right: 5px;
}

.folgas {
  width: 25px;
  height: 20px;
  background: #6ece87;
  border-radius: 7px 7px 7px 7px;
  -moz-border-radius: 7px 7px 7px 7px;
  -webkit-border-radius: 7px 7px 7px 7px;
  border: none;
  margin-right: 5px;
}

.batidas {
  margin-right: 5px;
}
</style>
